import { Api } from "./api";

let instance = null

export class Invoicexpress {

    invoiceAppName = null;

    constructor(){
        if(instance) return instance;
        
        instance = this;
        this.api = new Api();
        this.invoiceAppName = this.api.isEnvProd ? "arowanalda" : "arowanadev";
        this.invoiceBaseLink = `https://${this.invoiceAppName}.app.invoicexpress.com/`;
    }

    openInvoice(invoiceId,invoiceType = "invoice"){

        if( invoiceId === "undefined" ) return;
        
        let invoiceLink = "";
        switch(invoiceType.toLowerCase())
        {
            case "invoicereceipt":
                invoiceLink = this.invoiceBaseLink + `invoice_receipts/${invoiceId}`;
                break;
            case "receipt":
                invoiceLink = this.invoiceBaseLink + `receipts/${invoiceId}`;
                break;
            case "creditnote":
                invoiceLink = this.invoiceBaseLink + `credit_notes/${invoiceId}`;
                break;
            default:
                invoiceLink = this.invoiceBaseLink + `invoices/${invoiceId}`;
                break;
        }
        window.open(invoiceLink);
    }

    getInvoiceData(invoiceId,type="invoice"){
        return this.api.get(`invoicexpress_invoices/${invoiceId}`,{invoice_type:type})
        .then(({data=null})=>{
            return data;
        });
    }

    getInvoiceClient(clientId){
        return this.api.get(`invoicexpress_clients/${clientId}`)
        .then(({data=null})=>{
            return data;
        });
    }

    openClient(clientId){

        if( clientId === "undefined" ) return;
        
        let invoiceLink = this.invoiceBaseLink + `clients/${clientId}`;
        window.open(invoiceLink);
    }

    openInvoicePdf(invoiceId){
        this.getInvoiceData(invoiceId).then(data=>{window.open(data.invoice.permalink);});
    }

}